/*
 * @FilePath     : /fe-escontact/src/plugins/basic.js
 * @Author       : LiYang
 * @Date         : 2021-08-12 15:11:34
 * @LastEditTime : 2021-11-10 19:13:39
 * @LastEditors  : Please set LastEditors
 * @Description  : 增加classnames 和 trigger
 */
import { classNames } from '@didi/es-mpx-shared'

export default app => {
  app.injectMixins({
    methods: {
      $classnames () {
        return classNames.apply(null, arguments)
      },

      $trigger (name, defailt, option) {
        this.triggerEvent(name, defailt, option)
      },

      $descendant(componentName) {
        const descendant = (this.$children || []).slice();
        const result = [];
        while(descendant.length) {
          const current = descendant.shift();
          if(current) {
            if(
              current.$rawOptions
              && current.$rawOptions.componentName
              && current.$rawOptions.componentName === componentName
            ) {
              result.push(current)
            }

            if(current.$children && current.$children.length) {
              descendant.unshift(...current.$children)
            }
          }
        };
        return result;
      },

      $ancestor(componentName) {
        var parent = this.$parent;
        var name = parent?.$rawOptions?.componentName;
  
        while (parent && (name !== componentName)) {
          parent = parent.$parent;
  
          if (parent) {
            name = parent?.$rawOptions?.componentName;
          }
        }

        if (!parent) {
          return null
        }

        return parent;
      }
    }
  }, 'component')
}
